module.exports = __webpack_public_path__ + "static/img/pro-bowl.db82c2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pro-bowl.png
// module id = NtPT
// module chunks = 1